import { PlatformTypeEnum } from '../common/model/type/platform-type.enum';
import axios from 'axios';
import { SURVEY_ROUTE } from '../api/backend';
import { SurveyInstance } from '../common/model/dto/survey/survey-instance';
import { SurveyResponse } from '../common/model/dto/survey/survey-response';
import { Constants } from '../common/constants';
import moment from 'moment';
import { CreateSurveyResponse } from '../common/model/dto/survey/create-survey-response';

export class SurveyService {
  static async getActiveNpsSurvey(
    platform: PlatformTypeEnum
  ): Promise<SurveyInstance> {
    const { data } = await axios.get<SurveyInstance>(
      `${SURVEY_ROUTE}/active-nps-survey?platform=${platform}`
    );

    return data;
  }

  static async sendSurveyResponse(
    surveyResponse: CreateSurveyResponse
  ): Promise<SurveyResponse> {
    const { data } = await axios.post<SurveyResponse>(
      `${SURVEY_ROUTE}`,
      surveyResponse
    );

    return data;
  }

  // TODO use real backend for this later, especially when more clients will want to snooze surveys, but keep it simple now
  static snoozeNpsSurvey(userId: string): void {
    localStorage.setItem(
      `${Constants.LOCAL_STORAGE_KEYS.NPS_SURVEY_SNOOZING_DATE}::${userId}`,
      moment().add(3, 'days').valueOf() + ''
    );
  }

  static isNpsSurveySnoozed(userId: string): boolean {
    const snoozedUntil = localStorage.getItem(
      `${Constants.LOCAL_STORAGE_KEYS.NPS_SURVEY_SNOOZING_DATE}::${userId}`
    );

    return snoozedUntil
      ? new Date(parseInt(snoozedUntil, 10)) > new Date()
      : false;
  }
}
